"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20014ToJSON = exports.InlineResponse20014FromJSONTyped = exports.InlineResponse20014FromJSON = void 0;
function InlineResponse20014FromJSON(json) {
    return InlineResponse20014FromJSONTyped(json, false);
}
exports.InlineResponse20014FromJSON = InlineResponse20014FromJSON;
function InlineResponse20014FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorId': json['errorId'],
    };
}
exports.InlineResponse20014FromJSONTyped = InlineResponse20014FromJSONTyped;
function InlineResponse20014ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errorId': value.errorId,
    };
}
exports.InlineResponse20014ToJSON = InlineResponse20014ToJSON;
